import React, { useState } from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import RecallParkedSaleDialogContent from './RecallParkedSaleDialogContent.container';
import { IRecallParkedSaleDialogContentHandle, IRecallParkedSaleDialogProps } from './RecallParkedSaleDialog.properties';
import { IFormViewModelHandle } from 'components/common/Modals/FormViewModal.properties';
import { isNull } from 'utils/utils';
import { ProcessValidationFormsContext } from 'utils/processValidationForms';
import { recallParkedSale } from 'api/Worksale/worksale';

const RecallParkedSaleDialog = (props: IRecallParkedSaleDialogProps) => {
    const { open, loading, worksaleId, onCancel, onRecall, dialogStyles } = props;

    const cancelBtnRef = React.useRef<HTMLButtonElement>();
    const contentRef = React.useRef<IRecallParkedSaleDialogContentHandle>();
    const filterRef = React.useRef({ isOpen: false });
    const formViewModalRef = React.useRef<IFormViewModelHandle>();
    const recallButtonRef = React.useRef<HTMLButtonElement>();
    const [gridLength, setGridLength] = React.useState(0);
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [isProcessing, setIsProcessing] = useState<boolean>(false);

    const onGridTabOut = () => {
        formViewModalRef.current?.focusFirstButton();
    };

    const handleFilterButtonShiftTab = React.useCallback(
        () => {
            if (gridLength > 0) {
                formViewModalRef.current?.focusLastButton();
            } else {
                formViewModalRef.current?.focusFirstButton();
            }
        },
        [formViewModalRef.current]
    );

    const processValidationForms = React.useContext(ProcessValidationFormsContext);
    const recallParkedSaleApi = async (query) => {
        setIsProcessing(true);
        const response = await recallParkedSale(query);
        setIsProcessing(false);

        return processValidationForms(response, query, recallParkedSale);
    };

    return (
        <div>
            <FormViewModal
                open={open}
                title='Recall Sale'
                loading={loading}
                innerRef={formViewModalRef}
                filterRef={filterRef}
                dialogStyles={dialogStyles}
                modalContent={
                    <RecallParkedSaleDialogContent
                        innerRef={contentRef}
                        worksaleId={worksaleId}
                        recallButtonRef={recallButtonRef}
                        selectedRow={selectedRow}
                        filterRef={filterRef}
                        setSelectedRow={setSelectedRow}
                        onRecall={onRecall}
                        onCancel={onCancel}
                        onGridTabOut={onGridTabOut}
                        onFilterButtonShiftTab={handleFilterButtonShiftTab}
                        setGridLength={setGridLength}
                        recallParkedSaleApi={recallParkedSaleApi}
                    />
                }
                actions={[
                    {
                        title: 'Recall',
                        iconName: 'CheckCircle',
                        isDefault: gridLength > 0,
                        disabled: (gridLength === 0) || isNull(selectedRow) || isProcessing,
                        ref: recallButtonRef,
                        listener: () => {
                            if (contentRef.current) {
                                contentRef.current.recall();
                            }
                        }
                    },
                    {
                        title: 'Cancel',
                        iconName: 'Cancel',
                        listener: () => {
                            if (onCancel) {
                                onCancel();
                            }
                        },
                        ref: cancelBtnRef
                    }
                ]}
                dialogActionsButtons={true}
                dialogActionsShadow={false}
                onActionsTabOut={() => {
                    contentRef.current.focusFilterButton();
                }}
                onActionShiftTabOut={() => {
                    if (gridLength > 0) {
                        contentRef.current.focusGrid();
                    } else {
                        contentRef.current.focusFilterButton();
                    }
                }}
            />
        </div>
    );
};

export default RecallParkedSaleDialog;
